import { render, staticRenderFns } from "./ProfileSubscriptionUpgrade.vue?vue&type=template&id=5afeb3fb&scoped=true&"
import script from "./ProfileSubscriptionUpgrade.vue?vue&type=script&lang=js&"
export * from "./ProfileSubscriptionUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSubscriptionUpgrade.vue?vue&type=style&index=0&id=5afeb3fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afeb3fb",
  null
  
)

export default component.exports